<template>

    <FloatingPanel title="Instellingen">

        <div class="canvas::blocks-modules-news-BlockPanel">

            <Tabs :tabs="[
                'Instellingen',
                'Algemeen',
            ]">

                <div slot="Instellingen">

                    <SwitchInput
                        label="Toon titel?"
                        :options="options"
                        options-property="show_title"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="1"
                        :open="true"
                    />

                </div>

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        SwitchInput,
        FloatingPanel,
        CommonInputs,
        Tabs,
    },

}

</script>
